import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/kshadmin/PanelRole/index",{
        params: {
            page:params
        }
    } )
}
function GET_SET_DATA(params) {
    return axios.get("/kshadmin/PanelRole/rule",{
        params: {
            role_id: params
        }
    } )
}
function SET_SUBMIT(params) {
    return  axios.post("/kshadmin/PanelRole/rulePost",{ ...params} )
}
export default {
    GET_LIST,
    GET_SET_DATA,
    SET_SUBMIT
}